import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { YSButton } from "../../uikit/YSButton";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import Alert from "@mui/material/Alert";
import { useLocation } from "react-router";
import {
  IDME_URL_DOMAIN,
  IDME_URL_END,
  REPORT_BASE_URL,
} from "../../Apis/Constants";
import { useDispatch, useSelector } from "react-redux";
import { loadingPrescriberDetails } from "../../Redux/Slice/PrescriberDetailsSlice";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
import { useSearchParams } from "react-router-dom";

export default function EPCSIdProofing({
  handleHideIdProofPopupClick,
  getProfileDetails,
}: any) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const verificationStatus: any = searchParams.get("verification_status");
  const [loading, setLoading] = useState(false);
  const PATIENT_SEARCH_URL = `https://${IDME_URL_DOMAIN}.h2hdigitalrx.com/idme/completeEpcsIdProofing?domain=drx.domain.ux.upgrade.${IDME_URL_END}.patientsearch`;
  const DASHBOARD_URL = `https://${IDME_URL_DOMAIN}.h2hdigitalrx.com/idme/completeEpcsIdProofing?domain=drx.domain.ux.upgrade.${IDME_URL_END}.dashboard`;
  const NEWRXPAD_URL = `https://${IDME_URL_DOMAIN}.h2hdigitalrx.com/idme/completeEpcsIdProofing?domain=drx.domain.ux.upgrade.${IDME_URL_END}.rxpad`;
  const PROFILE_SETTINGS = `https://${IDME_URL_DOMAIN}.h2hdigitalrx.com/idme/completeEpcsIdProofing?domain=drx.domain.ux.upgrade.${IDME_URL_END}.epcs.profilesettings`;
  const IFRAME_POPUP_URL = `https://${IDME_URL_DOMAIN}.h2hdigitalrx.com/idme/completeEpcsIdProofing?domain=drx.domain.ux.upgrade.${IDME_URL_END}.epcs.popupwindow`;

  const PrescriberDetailsState = useSelector((state: any) => {
    return { ...state.PrescriberDetailsSlice };
  }); //redux data
  const { AllPrescriberDetails } = PrescriberDetailsState;
  const { idProofingRequired } = AllPrescriberDetails;
  const handleVerification = async () => {
    setLoading(true);
    const popup = window.open(
      IFRAME_POPUP_URL,
      "popup",
      `width=screen.width,height=screen.height,top=0,left=0`
    );

    // Periodically check if the popup is closed
    const popupCheckInterval = setInterval(() => {
      if (popup && popup.closed) {
        clearInterval(popupCheckInterval); // Stop checking
        dispatch(loadingPrescriberDetails());
        // Add Profile settings API
        getProfileDetails();
        setLoading(false);
      }
    }, 500); // Check every 500ms
  };

  // useEffect(() => {
  //   if (idProofingRequired === false) {
  //     handleHideIdProofPopupClick();
  //   }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [idProofingRequired]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          height: "73vh",
        }}
      >
        <CircularProgress color="primary" />
        <Typography
          variant="body1"
          color={"primary"}
          component="div"
          fontWeight={500}
        >
          Please complete the ID proofing process to gain access to the EPCS.
        </Typography>
      </div>
    );
  }

  return (
    <>
      <Grid
        container
        item
        xs={12}
        spacing={1}
        alignItems="top"
        justifyContent="center"
        padding={1}
      >
        <Grid container rowSpacing={1} columnSpacing={2}>
          {verificationStatus === "1" ? (
            <Grid item xs={12} my={1}>
              <Alert variant="filled" severity="error">
                You have not authorized H2H DRx to get your ID proofing and 2FA
                values. It will impact your EPCS Capability. <br />
                Please login again and click "Approve" to authorize H2H DRx to
                get values. Thank you!
              </Alert>
            </Grid>
          ) : verificationStatus === "2" ? (
            <Grid item xs={12} my={1}>
              <Alert variant="filled" severity="error">
                You have not completed DEA verification and not authorized H2H
                DigitalRx to get your ID proofing and 2FA values. It will impact
                your EPCS Capability.
                <br />
                Please login again and complete DEA verification and click
                "Approve" to authorize H2H DigitalRx to get values. Thank you!
              </Alert>
            </Grid>
          ) : null}
          <Grid item xs={12} md={12}>
            <Typography component={"p"} variant={"h5"} fontWeight={700}>
              Enroll with ID.me for ID Proofing & Two factor authentication for
              H2H Digital Rx EPCS capability.
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography component={"div"} variant={"body1"}>
              Prescriber identity proofing is mandated as per guidelines
              provided by Drug Enforcement Agency (DEA) and the National
              Institutes of Standards and Technology (NIST) starting from
              September 1, 2022 to protect and improve the privacy and security
              of the data.
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} my={1}>
            <Typography component={"p"} variant={"subtitle2"}>
              Have this ready and on-hand with you before ID.me Registration:
              <ol>
                <li>Personal Email-ID & Mobile number</li>
                <li>
                  SSN, NPI & DEA Certification [You will be asked to check each
                  DEA schedule that you are certified to prescribe]
                </li>
                <li>
                  State license [OR] State ID [OR] Passport [OR] Passport card
                  for ID proofing
                </li>
                <li>
                  An Android or IOS (Apple) smartphone with Internet & camera to
                  download mobile app & scan QR Code
                </li>
                <li>
                  ID.me requires your consent to share your identity information
                  with H2H Digital Rx to get the access to your H2H Digital Rx
                  account you must click on "Allow" at the consent page.
                </li>
              </ol>
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} textAlign={"center"} my={2}>
            <YSButton
              children="Verify with ID.me"
              variant="contained"
              startIcon={<VerifiedUserOutlinedIcon />}
              type="button"
              onClick={() => {
                if (window.self !== window.top) {
                  handleVerification();
                } else {
                  window.open(
                    `${
                      location.pathname === "/patientsearch"
                        ? PATIENT_SEARCH_URL
                        : location.pathname === "/newrxpad"
                        ? NEWRXPAD_URL
                        : location.pathname === "/profile-settings"
                        ? PROFILE_SETTINGS
                        : DASHBOARD_URL
                    }`,
                    "_self"
                  );
                }
              }}
              size="large"
              className=""
            />
          </Grid>
          <Grid item xs={12} md={12} my={1}>
            <Typography component={"p"} variant={"h6"} fontWeight={600}>
              HELP DOCUMENTS:
            </Typography>
            <Typography component={"p"} variant={"subtitle2"}>
              <ul>
                {/* https://www.h2hdigitalrx.com/drx/PDF/ID.me_UserGuide_V_3.3.pdf */}
                <li>
                  Here is the{" "}
                  <a
                    href={`${REPORT_BASE_URL}drx/PDF/ID.me_UserGuide_V_3.3.pdf`}
                    style={{ color: "#0992bb" }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Enrollment Guide
                  </a>{" "}
                  to access directions on how to begin registering with ID.me
                  now. The process should take between 10-20 minutes
                </li>
                {/* https://www.h2hdigitalrx.com/H2H+ID.me_%20Info_Rollout.pdf */}
                <li>
                  Here is the{" "}
                  <a
                    href={`${REPORT_BASE_URL}H2H+ID.me_ Info_Rollout.pdf`}
                    style={{ color: "#0992bb" }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    H2H+ID.me_Info
                  </a>{" "}
                  supporting document which speaks about why do prescribers need
                  to verify thier identity with ID.me
                </li>
                {/* https://www.h2hdigitalrx.com/Virtual_In_Person_Proofing_June_2019_H2H_DigitalRx.pdf */}
                <li>
                  Here is the "
                  <a
                    href={`${REPORT_BASE_URL}Virtual_In_Person_Proofing_June_2019_H2H_DigitalRx.pdf`}
                    style={{ color: "#0992bb" }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Virtual in Person Proofing
                  </a>
                  " document to understand what will be required of providers
                  that are unsuccessful in the online identity proofing workflow
                  during initial enrollment with ID.me
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={2} my={1}>
          <Grid item xs={12} md={12}>
            <Alert variant="filled" severity="warning">
              <b>Note:</b> If ID Proofing takes more than 15mins to complete the
              process you may land on a session expired page at the end. No
              Worries, Please login back you will not see this pop up screen
              again if your registration was successful.
            </Alert>
          </Grid>
          <Grid item xs={12} md={12}>
            <Alert variant="filled" severity="info">
              In doubt, Please reach out to us at: drxsupport@h2hsolutions.com
              or Call at:+1 (248)-675-1200 Ext: 429
            </Alert>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
